import { jsx } from "react/jsx-runtime";
import "lodash.find";
import "react";
import "../../../common/UI/Loaders/Activity.js";
import "@flatfile/design-system";
import "react-i18next";
import "../Lookup/Styles.js";
import "match-sorter";
import Renderer$1 from "../Lookup/Renderer.js";
import { getCellValueIsEmpty } from "../../../utils/cells.js";
const getValueHasCorrectFormat = (value) => {
  return getCellValueIsEmpty(value) || Array.isArray(value);
};
const getFormattedValue = (value, status, isDiffView, columnConfig) => {
  if (getCellValueIsEmpty(value)) {
    return value;
  }
  const error = isDiffView ? false : status.error;
  const warning = isDiffView ? false : status.warning;
  if (Array.isArray(columnConfig == null ? void 0 : columnConfig.options)) {
    const option = columnConfig == null ? void 0 : columnConfig.options.find((o) => o.value === value);
    return [
      option ? { ...option, error, warning } : {
        value,
        label: value === null ? "null" : value == null ? void 0 : value.toString(),
        error: !isDiffView
      }
    ];
  }
  return [
    {
      value,
      label: value === null ? "null" : value == null ? void 0 : value.toString(),
      error,
      warning
    }
  ];
};
const getCell = ({
  cell,
  columnConfig,
  status,
  isDiffView
}) => {
  const value = cell == null ? void 0 : cell.value;
  const diffValue = cell == null ? void 0 : cell.diffValue;
  if (getValueHasCorrectFormat(value) && (!isDiffView || getValueHasCorrectFormat(diffValue))) {
    return cell;
  }
  return {
    ...cell,
    value: getFormattedValue(value, status, isDiffView, columnConfig),
    diffValue: getFormattedValue(
      cell == null ? void 0 : cell.diffValue,
      status,
      isDiffView,
      columnConfig
    )
  };
};
const Renderer = (props) => {
  return /* @__PURE__ */ jsx(Renderer$1, { ...props, cell: getCell(props) });
};
export {
  Renderer as default
};
